import React from 'react'
import parse from 'html-react-parser'
import feather from 'feather-icons'

import classNames from 'classnames'

// import styles from './style.module.scss'

function FeatherIcon(props) {
  const { name, ...rest } = props

  const attrs = {
    ...rest,
    class: classNames('fe', rest.class),
  }

  const svg = feather.icons[name].toSvg(attrs)
  const icon = parse(svg)

  return <React.Fragment>{icon}</React.Fragment>
}

export default FeatherIcon
